import React, { memo, useEffect, useState } from 'react';
import { t } from 'ttag';

function Cart() {
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const getCartCount = async () => {
      const response = await fetch('/cart/items/count/');

      if (!response.ok) {
        return 0;
      }

      const { count } = await response.json();

      return count;
    };

    getCartCount().then(setCartCount);
  }, []);

  return (
    <a
      href="/cart/"
      className="relative flex items-center p-3 text-black outline-none focus:outline-none"
      aria-label={t`Go to your cart`}
    >
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 shrink-0"
      >
        <g clipPath="url(#a)">
          <path
            d="M16 9V6a4 4 0 0 0-8 0v3m-4.408 1.352-.6 6.4c-.17 1.82-.256 2.73.046 3.432a3 3 0 0 0 1.32 1.45C5.03 22 5.944 22 7.771 22h8.458c1.828 0 2.742 0 3.413-.366a3 3 0 0 0 1.32-1.45c.302-.703.217-1.612.046-3.432l-.6-6.4c-.144-1.537-.216-2.305-.561-2.886a3 3 0 0 0-1.292-1.176C17.945 6 17.173 6 15.629 6H8.371c-1.543 0-2.315 0-2.925.29a3 3 0 0 0-1.292 1.176c-.346.581-.418 1.35-.562 2.886z"
            stroke="#000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h24v24H0z" />
          </clipPath>
        </defs>
      </svg>
      {cartCount > 0 && (
        <span className="absolute bottom-2 left-2 box-border flex h-5 w-5 items-center justify-center rounded-full border-2 border-solid border-white bg-black text-[8px] font-semibold leading-none text-white">
          {cartCount}
        </span>
      )}
    </a>
  );
}

export default memo(Cart);
